import { withRouter } from "react-router-dom";
import {ROUTES} from "../../constants";


function MobileRoute({location}) {
      window.location.href = `${window.location.protocol}//${window.location.host}${ROUTES.QUIZ.METEOR_PREFIX}${location.pathname}`;
      return <div>
          hallo
      </div>
  }
  export default withRouter(MobileRoute);
